import { CategoryTypes } from "../interfaces/enums";
import { CategoryWithId } from "../interfaces/ICategories";

const typeOrderMap: Record<string, number> = {
  [CategoryTypes.SOLO]: 0,
  [CategoryTypes.DUO]: 1,
  [CategoryTypes.TRIO]: 2,
  [CategoryTypes.OTHER]: 3,
};

export function compareCategoriesForDisplay(a: CategoryWithId, b: CategoryWithId): number {
  // 1) Dzień rosnąco
  const dayDiff =
    Number(a.day ?? Number.MAX_SAFE_INTEGER) - Number(b.day ?? Number.MAX_SAFE_INTEGER);
  if (dayDiff !== 0) return dayDiff;

  // 2) Typ: Solo, Duet, Trio, Inne
  const typeA = typeOrderMap[String(a.type)] ?? Number.MAX_SAFE_INTEGER;
  const typeB = typeOrderMap[String(b.type)] ?? Number.MAX_SAFE_INTEGER;
  if (typeA !== typeB) return typeA - typeB;

  // 3) Rozmiar grupy (max uczestników w prezentacji) rosnąco
  const sizeA = Number(a.maxPresentationSize ?? Number.MAX_SAFE_INTEGER);
  const sizeB = Number(b.maxPresentationSize ?? Number.MAX_SAFE_INTEGER);
  if (sizeA !== sizeB) return sizeA - sizeB;

  // 4) Minimalna data urodzenia uczestnika malejąco (nowsze daty = młodsi uczestnicy = wcześniej)
  const minDateA = a.minParticipantBirthDate
    ? a.minParticipantBirthDate instanceof Date
      ? a.minParticipantBirthDate.getTime()
      : new Date(a.minParticipantBirthDate).getTime()
    : Number.MIN_SAFE_INTEGER;
  const minDateB = b.minParticipantBirthDate
    ? b.minParticipantBirthDate instanceof Date
      ? b.minParticipantBirthDate.getTime()
      : new Date(b.minParticipantBirthDate).getTime()
    : Number.MIN_SAFE_INTEGER;
  if (minDateA !== minDateB) return minDateB - minDateA; // Odwrotna kolejność (malejąco)

  // 5) Alfabetycznie po nazwie (jako ostatni krok)
  return String(a.name || "").localeCompare(String(b.name || ""), "pl");
}

